import { Injectable } from '@angular/core';
import { EntityListResolver } from 'src/app/core/services/entity-list.resolver';
import { LiftService } from './lift.service';
import { LiftList } from '../models/lift-list.model';
import { LiftModuleService } from './lift-module.service';
import { LiftModuleList } from '../models/lift-module-list.model';
import { LiftModuleCriteria } from '../models/lift-module.criteria';

@Injectable({
  providedIn: 'root'
})
export class LiftModuleListResolver extends EntityListResolver<LiftModuleService, LiftModuleList, LiftModuleCriteria> {
  constructor(
    liftModuleService: LiftModuleService
  ) {
    super(liftModuleService, new LiftModuleCriteria());
  }
}
